import React, { useEffect, useState } from "react";
import Clienthomemenu from "../Menus/Clienthomemenu";
import Setftestexammodule from "./Setftestexammodule";

export default function SelfTest() {
  const [subjects, setSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState("");
  const [topics, setTopics] = useState([]);

  const [questions, setQuestions] = useState([]);
  const [startExam, setStartExam] = useState(false);
  const [loading, setLoading] = useState(false);
  const [testid, setTestid] = useState("");

  const user = JSON.parse(localStorage.getItem("user"));
  const LANGUAGE_ID = user?.LANGUAGE_ID;
  const uid = user?.UID;

  /* ================= SUBJECT LIST ================= */
  useEffect(() => {
    fetchSubjects();
  }, []);

  const fetchSubjects = async () => {
    try {
      setLoading(true);
      const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_LIST_OF_SUBJECT}`;

      const res = await fetch(path, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          TRADE_ID: user?.TRADE_ID,
          TRADE_NAME: user?.TRADE_NAME,
        }),
      });

      const data = await res.json();

      if (data.res === "Success") {
        setSubjects(data.data);

        if (data.data.length > 0) {
          setSelectedSubject(data.data[0].TRADE_ID); // default first
        }
      }
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  /* ================= LOAD TOPICS ON SUBJECT CHANGE ================= */
  useEffect(() => {
    if (selectedSubject) {
      fetchTopics(selectedSubject);
    }
  }, [selectedSubject]);

  const fetchTopics = async (tradeId) => {
    try {
      const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_LIST_OF_TOPIC}`;

      const res = await fetch(path, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          TRADE_ID: tradeId, // ✅ IMPORTANT
        }),
      });

      const data = await res.json();

      if (data.res === "success") {
        setTopics(data.data);
      } else {
        setTopics([]);
      }
    } catch (err) {
      console.error(err);
    }
  };

  /* ================= START EXAM ================= */
  const handleStartTest = (topic) => {
    setLoading(true);

    const payload = {
      TRADE_ID: selectedSubject,
      TOPIC_UID: topic.TOPIC_UID,
      NUM_OF_QUE: 10,
      LANGUAGE_ID: LANGUAGE_ID,
    };

    const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_GET_QUESTION1}`;

    fetch(path, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.res === "success") {
          setQuestions(data.data);
          setTestid(data.TEST_UID || "");
          setStartExam(true);
        } else {
          alert(data.msg || "No questions found");
        }
        setLoading(false);
      })
      .catch(() => {
        alert("Server error");
        setLoading(false);
      });
  };

  /* ================= OPEN EXAM ================= */
  if (startExam) {
    return (
      <Setftestexammodule questions={questions} testid={testid} userid={uid} />
    );
  }

  return (
    <>
      <Clienthomemenu title="EasyITI" testhistory="testhistory" />

      <div className="container" style={{ height: "auto", width: "auto", paddingTop: "90px", }}>
        {loading ? (
          <>
            <div className="skeleton-label"></div>
            <div className="skeleton-dropdown"></div>

            <div className="row mt-4">
              {[...Array(6)].map((_, i) => (
                <div className="col-md-4 mb-3" key={i}>
                  <div className="card p-3 shadow-sm">
                    <div className="skeleton-title"></div>
                    <div className="skeleton-text"></div>
                  </div>
                </div>
              ))}
            </div>
          </>
        ) : subjects.length === 0 ? (
          <div className="text-center mt-5">
            <div className="card p-4 shadow-sm">
              <h5>⚠ Failed to Load Subjects</h5>
              <p>Please refresh to fetch data</p>

              <button
                className="btn btn-primary"
                onClick={() => fetchSubjects()}
              >
                🔄 Refresh
              </button>
            </div>
          </div>
        ) : (
          <>
            {/* SUBJECT */}
            <label className="form-label">Select Subject</label>
            <select
              className="form-select"
              value={selectedSubject}
              onChange={(e) => setSelectedSubject(e.target.value)}
            >
              {subjects.map((item) => (
                <option key={item.TRADE_ID} value={item.TRADE_ID}>
                  {item.TRADE_NAME}
                </option>
              ))}
            </select>

            {/* TOPICS */}
            <div style={{ maxHeight: "70vh", overflowY: "auto" }}>
              <div className="row mt-4">
                {topics.map((topic) => (
                  <div className="col-md-4 mb-3" key={topic.TOPIC_UID}>
                    <div
                      className="card p-3 shadow-sm text-center topic-card"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleStartTest(topic)}
                    >
                      <h6>{topic.TOPIC_NAME}</h6>
                      <small>Click to start exam</small>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}
